import React from 'react';

type Variant = 'primary' | 'ghost' | 'ghost-active';

const VARIANT_CLASSES: Record<Variant, string> = {
  primary:
    'text-brand-bg bg-linear-to-br from-brand-teal to-brand-blue shadow-[0_3px_16px_rgba(70,192,186,0.25)] hover:shadow-[0_6px_28px_rgba(70,192,186,0.45)] hover:-translate-y-px active:scale-[0.98] disabled:opacity-60 disabled:pointer-events-none',
  ghost:
    'text-white/60 bg-white/5 border border-white/10 hover:text-brand-teal hover:border-brand-teal/30 hover:bg-brand-teal/6',
  'ghost-active': 'text-brand-teal bg-brand-teal/8 border border-brand-teal/30 cursor-default',
};

export const Button = ({
  variant = 'primary',
  className = '',
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) => {
  return (
    <button
      className={`flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold transition-all duration-200 cursor-pointer ${VARIANT_CLASSES[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
